import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {Link, StaticMethods} from '../../model/GeneralModels';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-main-nav-bar',
  template: `
    <div id="wrapper" class="" [scrollTop]="onScroll()">
      <nav id="main-nav-bar" class="header ">
        <div class="container d-flex align-items-stretch header-menu">
          <div class="item d-block d-lg-none order-0">
            <div class="icon-item" data-trigger-drawer="menu">
              <span (click)="showMenu()" class="lnr lnr-menu-circle" style="padding-right: 20px"></span>
            </div>
          </div>
          <div class="item order-12 order-md-1">
            <a class="icon-item no-hover hashtagbime-logo d-sm-none d-md-block"
               routerLink="/">
              <!--<i class="icon-logo"></i>-->
              <img src="assets/images/logo.png" alt="hashtagbime" width="129" height="42">
            </a>
          </div>
          <div class="item order-2 flex-fill no-cursor justify-content-start align-items-center d-flex
             item-home">
          </div>

          <div class="item order-3 d-none d-md-flex justify-content-center align-items-center">
            <a id="phone-number-a-link-item" class="link-item no-hover home-page " href="tel:+982186112835">
              <span id="phone-number" class="numeric color-pin-white">۰۲۱-۸۶۱۱۲۸۳۵ </span>
              <i class="lnr lnr-phone-handset color-pin-white" style="color: darkorange"></i>
            </a>
          </div>
          <div class="item user-icon order-1 mr-1 order-md-4  active color-white ">
            <div class="d-flex align-items-center h-100">
              <div *ngIf="!mobile" (click)="login()" class="btn login-btn home-page " title="ورود / عضویت">
                ورود / عضویت
              </div>
              <button *ngIf="mobile" mat-button [matMenuTriggerFor]="loggedInMenu" class="btn login-btn home-page "
                      title="{{mobile}}">
                {{mobile}} <i class="lnr lnr-users"></i>
              </button>
              <mat-menu #loggedInMenu="matMenu" xPosition="after">
                <button mat-menu-item routerLink="/profile">پروفایل</button>
                <button mat-menu-item *ngIf="myRequestsURL" routerLink="{{myRequestsURL}}">بیمه های من</button>
                <button mat-menu-item routerLink="/logout" [state]="state">خروج</button>
              </mat-menu>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <nav class="navbar navbar-inverse bg-primary ">
      <div class="d-none d-lg-flex justify-content-right top-menu">
        <ul class="nav navbar-nav">
          <li *ngFor="let item of linksList"><a routerLink="{{item.url}}"
                                                routerLinkActive="active-link">{{item.label}}</a></li>
        </ul>
      </div>
    </nav>
    <!--end nav 2-->
    <!--menu sidebar-->
    <div id="menu" (click)="closeDrawer()" class="drawer">
      <div class="drawer-sider">
        <div class="menu-header">
          <a class="text-decoration-none inline-middle"
             href="http://www.hashtagbime.com">
            <img src="assets/images/logo.png" alt="hashtagbime" width="129" height="42">
          </a>
        </div>
        <div class="menu-content">
          <div *ngIf="linksList">
            <div *ngFor="let item of linksList">
              <a routerLink="{{item.url}}" routerLinkActive="active-link">
                <span class="lnr {{item.icon}}">{{item.label}}</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end sidebar-->
  `,
  styleUrls: [
    '../../assets/css/light.theme.css',
    '../../assets/css/navbar.css'
  ],
  styles: [`
  ::ng-deep .mat-menu-content {
    min-width: 130px !important;
  }
  `]
})
export class MainNavBarComponent implements OnInit {

  mobile = '';
  role: string;
  state: {
    mobile: string,
    role: string
  };
  myRequestsURL: string;
  linksList: Link[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private settings: AppSettingsService
  ) {
  }

  ngOnInit() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.state = history.state;
    this.role = this.state.role || StaticMethods.getRole(this.router.url);
    this.mobile = this.authService.decode() && this.authService.decode().Role === this.role
      ? this.authService.decode().auth : '';
    this.getLinksList();
  }

  onScroll() {
    const mainNavbarElement = document.getElementById('main-nav-bar');
    const numberLinkElement = document.getElementById('phone-number-a-link-item');
    const numberElement = document.getElementById('phone-number');
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0;
    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 10) {
        mainNavbarElement.style.backgroundColor = '#FFF';
        mainNavbarElement.style.height = '60px';
        mainNavbarElement.style['box-shadow'] = '0 8px 20px 0 rgba(8, 8, 8, .3)';
        numberLinkElement.style.backgroundColor = '#294187';
        numberElement.style.color = '#fff';
      } else {
        mainNavbarElement.style.backgroundColor = 'transparent';
        mainNavbarElement.style.height = '80px';
        mainNavbarElement.style['box-shadow'] = 'none';
        numberLinkElement.style.backgroundColor = '#fff';
        numberElement.style.color = 'lightblue';
      }
    };
  }

  showMenu() {
    const drawer = document.getElementById('menu');
    drawer.classList.add('opened');
  }

  closeDrawer() {
    const drawer = document.getElementById('menu');
    if (drawer.classList.contains('opened')) {
      drawer.classList.remove('opened');
    }
  }

  login() {
    const url = this.router.url;
    this.state.role = this.role;
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: url
      },
      state: this.state
    });
  }

  getLinksList() {
    const productName = StaticMethods.getProductName(this.router, false);
    const applicationUrl = '/' + ((StaticMethods.getBaseUrl(productName,
      this.authService.decode() ? this.authService.decode().Role : null)) || '');
    console.log('homeUrl ', applicationUrl);
    console.log('router.url ', this.router.url);
    this.myRequestsURL = productName !== 'NOT_SET' && productName !== 'EXTERNAL_EMPLOYEE'
      ? `/${productName}/requests` : null;
    this.linksList = [];
    if (applicationUrl !== '/') {
      this.linksList[this.linksList.length] = new Link(this.settings.translateEnglish(productName),
        applicationUrl,  this.settings.getIcon(productName));
    }
    switch (productName) {
      case 'HEALTH':
        // this.linksList[this.linksList.length] = new Link('مراکز درمان اطراف من', '/health/family/near-me', 'lnr-location');
        break;
      case 'INDIVIDUAL_ACCIDENTS':
        break;
      case 'MOBILE':
        break;
    }
  }
}
